// Formatage des noms des collaborateurs (staff).
// Prénom : première lettre de chaque partie en majuscule, le reste en minuscule
//          (gère les prénoms composés : "marie-noel" -> "Marie-Noel", "jean pierre" -> "Jean Pierre").
// Nom : tout en majuscules.

export function formatPrenom(prenom?: string | null): string {
     if (!prenom) return ""
     return prenom
          .trim()
          .split(/([\s\-']+)/) // conserve les séparateurs (espace, tiret, apostrophe)
          .map(part => (/^[\s\-']+$/.test(part) || part === "" ? part : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()))
          .join("")
}

export function formatNom(nom?: string | null): string {
     return (nom ?? "").trim().toUpperCase()
}

export function formatPrenomNom(prenom?: string | null, nom?: string | null): string {
     return `${formatPrenom(prenom)} ${formatNom(nom)}`.trim()
}
